import { render, staticRenderFns } from "./MaddenRecap2021.vue?vue&type=template&id=0d516354&scoped=true&"
import script from "./MaddenRecap2021.vue?vue&type=script&lang=js&"
export * from "./MaddenRecap2021.vue?vue&type=script&lang=js&"
import style0 from "./MaddenRecap2021.vue?vue&type=style&index=0&id=0d516354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d516354",
  null
  
)

export default component.exports